import { useMe } from "@quortex/front-common"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import Illustration from "src/images/illustration-undraw-opened.svg"
import { useAccountCreation } from "@/stores/AccountCreation"

const FinishedStep = () => {
  const { data: me } = useSuspenseQuery(useMe())
  const { setAwsMarketplaceToken, awsMarketplaceToken } = useAccountCreation(store => store)

  useEffect(() => {
    if (awsMarketplaceToken) {
      setAwsMarketplaceToken("")
    }
  }, [awsMarketplaceToken, setAwsMarketplaceToken])

  return (
    <div className="flex w-[32rem] flex-col items-center gap-xl">
      <h1 className="font-medium text-2xl">We’ll get back to you shortly.</h1>
      <img alt="" src={Illustration} />
      <p className="text-center text-grey-600">
        We will send an email to <strong>{me.email}</strong> as soon as the organization is ready.
      </p>
    </div>
  )
}

export default FinishedStep
